/** Totem of undying (pure): a held totem (either hand) cancels a lethal hit. */
import { I } from '../itemIds';
import { FX, type EffectSet } from '../effects/effects';
import { clearStack, isEmpty, type Stack } from '../types';

/** Consume a totem from the given hands (main hand first); true when one was used. */
export function popTotem(hands: Stack[]): boolean {
  for (const s of hands) {
    if (!isEmpty(s) && s.id === I.TOTEM_OF_UNDYING) { clearStack(s); return true; }
  }
  return false;
}

/** Vanilla aftermath: effects cleared, Regeneration II 45 s, Absorption II 5 s, Fire Resistance I 40 s. */
export function applyTotemEffects(fx: EffectSet): void {
  fx.clear();
  fx.add(FX.REGENERATION, 1, 45 * 20);
  fx.add(FX.ABSORPTION, 1, 5 * 20);
  fx.add(FX.FIRE_RESISTANCE, 0, 40 * 20);
}
